var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dropdown } from 'primereact/dropdown';
var MdlPaginatorLeft = function (_a) {
    var id = _a.id, first = _a.first, rows = _a.rows, total = _a.total, onRowsChange = _a.onRowsChange, _b = _a.options, options = _b === void 0 ? [12, 25, 50] : _b;
    return (_jsxs("div", __assign({ className: "mdl-footer-left" }, { children: [_jsxs("span", __assign({ className: "mdl-footer-count" }, { children: ["Showing ", _jsx("b", { children: total === 0 ? 0 : first + 1 }), " to ", _jsx("b", { children: Math.min(first + rows, total) }), " of ", total] })), _jsxs("span", __assign({ className: "mdl-footer-rpp" }, { children: [_jsx("label", __assign({ htmlFor: id }, { children: "Rows per page" })), _jsx(Dropdown, { inputId: id, value: rows, options: options, onChange: function (e) { return onRowsChange(e.value); }, className: "mdl-rows-dropdown" })] }))] })));
};
export default MdlPaginatorLeft;
